


































































































































import BaseFormMixin from '@/mixins/base-form-mixin';
import DatasourceServices, { DatasourceDto, KafkaConf } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class KafkaConfForm extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;
  
  dsSrv = new DatasourceServices();
  sslType = 0;
  offset = 0;

  mounted() {
    this.syncFormData.kafkaConfDto = {
      bootstrapServers: '',
      groupId: '',
      topic: '',
      securityProtocol: '',
      sslKeyPassword: '',
       // securityProtocol = SSL 
      sslKeystoreLocation: '',
      sslKeystorePassword: '',
      sslKeystoreBase64: '',
      sslTruststoreLocation: '',
      sslTruststorePassword: '',
      sslTruststoreBase64: '',
      // securityProtocol = SASL_PLAINTEXT PLAIN
      saslMechanism: '', 
      saslUerName: '',
      saslPassword: '',
      krbKeyTab: '',
      krbPrincipal: '',
      // "org.apache.kafka.common.security.plain.PlainLoginModule required username=\"producer\" password=\"prod-test\";"
      saslJaasConfig: '',
      // earliest,lastest,none
      autoOffsetReset: ''
    };
  }

  @Watch('syncFormData.kafkaConfDto', { deep: true })
  onBaseChange() {
    if (this.syncFormData.kafkaConfDto.securityProtocol == 'SSL') {
      this.sslType = 0;
    } else if (this.syncFormData.kafkaConfDto.securityProtocol == 'SASL_PLAINTEXT') {
      if (this.syncFormData.kafkaConfDto.saslMechanism == 'PLAIN') {
        this.sslType = 1;
      } else if (this.syncFormData.kafkaConfDto.saslMechanism == 'GSSAPI') {
        this.sslType = 2;
      } 
    } else if (this.syncFormData.kafkaConfDto.securityProtocol == 'PLAINTEXT') {
      this.sslType = 3;
    }

    if (this.syncFormData.kafkaConfDto.autoOffsetReset == 'lastest') {
      this.offset = 0;
    } else if (this.syncFormData.kafkaConfDto.autoOffsetReset == 'earliest') {
      this.offset = 1;
    } else if (this.syncFormData.kafkaConfDto.autoOffsetReset == 'none') {
      this.offset = 2;
    }

  }

  changeOffset() {
    if (this.offset === 0) {
      this.syncFormData.kafkaConfDto.autoOffsetReset = 'lastest';
    } else if (this.offset === 1) {
      this.syncFormData.kafkaConfDto.autoOffsetReset = 'earliest';
    } else if (this.offset === 2) {
      this.syncFormData.kafkaConfDto.autoOffsetReset = 'none';
    }
  }
  changeSSL() {
      if (this.sslType === 0) {
        this.syncFormData.kafkaConfDto.securityProtocol='SSL';
      } else if (this.sslType === 1) {
        this.syncFormData.kafkaConfDto.securityProtocol='SASL_PLAINTEXT';
        this.syncFormData.kafkaConfDto.saslMechanism='PLAIN';
        this.syncFormData.kafkaConfDto.saslJaasConfig='org.apache.kafka.common.security.plain.PlainLoginModule required \nusername=\"'+ this.syncFormData.kafkaConfDto.saslUerName + '\" \npassword=\"' + this.syncFormData.kafkaConfDto.saslPassword + '\";"';
      } else if (this.sslType === 2) {
          this.syncFormData.kafkaConfDto.securityProtocol='SASL_PLAINTEXT';
          this.syncFormData.kafkaConfDto.saslMechanism='GSSAPI';
          this.syncFormData.kafkaConfDto.saslJaasConfig='com.sun.security.auth.module.Krb5LoginModule required \nuseKeyTab=true \nstoreKey=true \nkeyTab=\"' + this.syncFormData.kafkaConfDto.krbKeyTab + '\" \nprincipal=\"' + this.syncFormData.kafkaConfDto.krbPrincipal + '\";';
      } else {
        this.syncFormData.kafkaConfDto.securityProtocol='PLAINTEXT';
      }
  }

  async uploadSslKeystore(data: any) {
    const formData = new FormData()  
    formData.append('file', data.file)
    let res = await this.dsSrv.uploadKafkaSSLFile(formData);
    if(res) {
      this.syncFormData.kafkaConfDto.sslKeystoreBase64 = res.base64;
      this.syncFormData.kafkaConfDto.sslKeystoreLocation = res.fileName;
    }
  }

  async uploadSslTruststore(data: any) {
    const formData = new FormData()  
    formData.append('file', data.file)
    let res = await this.dsSrv.uploadKafkaSSLFile(formData);
    if(res) {
      this.syncFormData.kafkaConfDto.sslTruststoreBase64 = res.base64;
      this.syncFormData.kafkaConfDto.sslTruststoreLocation = res.fileName;
    }
  }

  async uploadKrbKeyTab(data: any) {
    const formData = new FormData()  
    formData.append('file', data.file)
    let res = await this.dsSrv.uploadKafkaSSLFile(formData);
    if(res) {
      this.syncFormData.kafkaConfDto.krbKeyTabBase64 = res.base64;
      this.syncFormData.kafkaConfDto.krbKeyTab = res.fileName;
    }
  }

}
